import React, { useState } from "react";
import { toast } from "react-toastify";
import "../admin/style.css";
import { deleteData, getData, postData, putData } from "../../api/method";
import ModalDelete from "../../components/admin/ModalConfirm";
import TableCategories from "../../components/admin/Category/table";
import ModalAdd from "../../components/admin/Category/add";
import ModalEdit from "../../components/admin/Category/edit";

function Categories(args) {
  const token = localStorage.getItem("token_key");

  const [openAdd, setOpenAdd] = useState(false);

  const toggleAdd = () => setOpenAdd(!openAdd);

  const closeBtnAdd = (
    <button className="close" onClick={toggleAdd}>
      &times;
    </button>
  );

  const [openEdit, setOpenEdit] = useState(false);

  const toggleEdit = () => setOpenEdit(!openEdit);

  const closeBtnEdit = (
    <button className="close" onClick={toggleEdit}>
      &times;
    </button>
  );

  const [openDel, setOpenDel] = useState(false);

  const toggleDel = () => setOpenDel(!openDel);

  const closeBtnDel = (
    <button className="close" onClick={toggleDel}>
      &times;
    </button>
  );

  const [error, setError] = useState({});
  const [name, setName] = useState("");

  const validation = (e) => {
    const msg = {};

    if (name === "") {
      msg.name = "Name is requied!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const handleSubmitAdd = async () => {
    const isValid = validation();
    const formData = new FormData();

    if (isValid) {
      formData.append("name", name);

      try {
        const res = await postData("/api/Category", formData);
        if (res.status === 200) {
          setOpenAdd(false);
          toast.success("Add success!");
          setName("");
        }
      } catch (err) {
        console.log(err);
        toast.error("Add fail!");
        setOpenAdd(false);
      }
    }
  };

  const [dataDel, setDataDel] = useState([]);

  const getCategoryByDel = async (id) => {
    try {
      const result = await getData(`/api/Category/${id}`);
      setDataDel(result.data);
      setOpenDel(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitDel = async (id) => {
    try {
      const res = await deleteData(`/api/Category/${id}`);
      if (res.status === 200) {
        setOpenDel(false);
        toast.success("Delete success!");
      }
    } catch (err) {
      console.log(err);
      setOpenDel(false);
      toast.error("Delete fail!");
    }
  };

  const [dataEdit, setDataEdit] = useState([]);

  const getCategoryByEdit = async (id) => {
    try {
      const result = await getData(`/api/Category/${id}`);
      setDataEdit(result.data);
      setOpenEdit(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitEdit = async (id) => {
    const isValid = validation();
    const editData = new FormData();

    if (isValid) {
      editData.append("name", name);
      editData.append("id", id);

      try {
        const res = await putData(`/api/Category/${id}`, editData);
        if (res.status === 200) {
          setOpenEdit(false);
          toast.success("Edit success!");
        }
      } catch (err) {
        console.log(err);
        setOpenEdit(false);
        toast.error("Edit fail!");
      }
    }
  };

  return (
    <div className="w-100 pt-4 px-5 py-5">
      <TableCategories
        toggleAdd={toggleAdd}
        getCategoryByDel={(id) => getCategoryByDel(id)}
        getCategoryByEdit={(id) => getCategoryByEdit(id)}
      />

      <ModalAdd
        isOpen={openAdd}
        toggle={toggleAdd}
        close={closeBtnAdd}
        onChange={(e) => setName(e.target.value)}
        onKeyUp={handleKeyUp}
        error={error}
        onClick={() => handleSubmitAdd()}
      />

      <ModalEdit
        toggle={toggleEdit}
        close={closeBtnEdit}
        isOpen={openEdit}
        onChange={(e) => setName(e.target.value)}
        onKeyUp={handleKeyUp}
        onClick={() => handleSubmitEdit(dataEdit.id)}
        data={dataEdit}
        error={error}
      />

      <ModalDelete
        title="Delete"
        text="Are you sure you want to delete the product category?"
        toggle={toggleDel}
        close={closeBtnDel}
        isOpen={openDel}
        onClick={() => handleSubmitDel(dataDel.id)}
      />
    </div>
  );
}

export default Categories;
